import { Link } from 'react-router-dom';
import S from './style';
import TranslateStatic from '../../locales/TranslateStatic';
import Accordion from '../../components/references/accordion';
import AccordionGaro from '../../components/references/accordionGaro';
import { LocaleContext } from '../../locale-context';

export function SSS() {
  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1><TranslateStatic string="SSSBaslik" /></h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <TranslateStatic string="SSSBaslik" />
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="faq-container">
          <LocaleContext.Consumer>
            {(value) => {
              if (value === "en") {
                return <AccordionGaro />;
              }
              return <Accordion />;
            }}
          </LocaleContext.Consumer>
        </div>
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
